import { Meeting, MeetingSession, MeetingState } from "@kalyzee/kast-web-sdk/websocket";
import { PlayersGrid } from "../player/PlayersGrid";
import { PlayerItem } from "../player/interfaces";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { BoxContainer } from "@kalyzee/kalyzee-ui";

import workBoxStyles from "./WorkBox.module.css";
import { SlavePlayerWorkBox } from "./SlavePlayerWorkBox";

export interface PlayerGridWorkBoxProps {
  meeting: Meeting;
  ownSession: MeetingSession;
  videoSessions: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData>[];
  columns?: number;
  rows?: number;
  gap?: number;
  label?: string;
  boxMode?: boolean;
};

export const PlayerGridWorkBox: React.FC<PlayerGridWorkBoxProps> = ({
  meeting,
  ownSession,
  videoSessions,
  columns,
  rows,
  gap,
  label,
  boxMode = true,
}) => {
  const sessionsToPlayerData = (): PlayerItem[] => {
    return videoSessions.map((videoSession) => {
      return new PlayerItem({
        type: "video_session",
        videoSession,
        extra: {
          meetingSession: videoSession.data.session,
          mediaSession: videoSession.data.mediaSession,
        }
      });
    });
  };

  const renderGrid = () => {
    const items = sessionsToPlayerData();
    return (
      <PlayersGrid
        items={items}
        style={{ width: "100%", flex: 1, minHeight: 0, padding: "1em" }}
        meeting={meeting}
        gridProps={{
          column: columns,
          row: rows,
          autoAdjust: false,
          gap: gap,
        }}
        noPages={true}
        renderItem={(renderDefaultPlayer, item) => {
          if (!item) return undefined;
          const itemData = item.getData();
          const session = itemData.extra?.meetingSession;
          const mediaSession = itemData.extra?.mediaSession;
          if (!session || !mediaSession) return renderDefaultPlayer();
          return (
            <SlavePlayerWorkBox
              ownSession={ownSession}
              session={session}
              mediaSession={mediaSession}
              mediaControls
              meetingOngoing={meeting.state === MeetingState.RUNNING}
            >
              {renderDefaultPlayer()}
            </SlavePlayerWorkBox>
          );
        }}
        defaultRendererProviderOptions={{
          hideSoundEffect: false,
          muted: true,
        }}
      />
    );
  };

  if (!boxMode) {
    return renderGrid();
  }
  
  return (
    <BoxContainer
      topBarProps={{
        center: [
          <span className={workBoxStyles.label}>
            {label ?? `${meeting.sessions?.length} Participant${meeting.sessions?.length ?? 0 > 1 ? "s" : ""}`}
          </span>
        ],
      }}
    >
      {renderGrid()}
    </BoxContainer>
  )
};